import React, { useState } from "react";
import { Modal, Form, Input, Button } from "antd";

import useCreate from "hooks/useCreate";
import useFormErrors from "hooks/useFormErrors";
import { name_regexp } from "helpers/regexp";
import { useIssueKinds } from "context/providers/issue_kinds";

const CreateIssueKindModal = ({ create_issue_kind_ref, setOpenEditTour }) => {
  const [is_open_create_modal, setOpenCreateModal] = useState(false);

  const [form] = Form.useForm();

  const { pristine, has_error, onFieldsChange } = useFormErrors();
  const { refetch } = useIssueKinds();

  const { is_saving, create } = useCreate({
    path: "/issue_kinds",
    form,
    onSuccess: async (data) => {
      await refetch();
      if (data.length === 1) {
        setOpenEditTour(true);
      }
    },
  });

  const handleOk = () => form.submit();
  const handleClose = () => setOpenCreateModal(false);

  return (
    <>
      <Button
        ref={create_issue_kind_ref}
        type="primary"
        htmlType="button"
        onClick={() => setOpenCreateModal(true)}
      >
        Dodaj
      </Button>
      <Modal
        style={{ top: 45 }}
        maskClosable={false}
        title="Dodaj rodzaj zgłoszenia"
        open={is_open_create_modal}
        onOk={handleOk}
        onCancel={handleClose}
        cancelText="Anuluj"
        okText="Dodaj"
        okButtonProps={{
          disabled: pristine || has_error,
          loading: is_saving,
        }}
      >
        <Form
          form={form}
          layout="vertical"
          onFieldsChange={onFieldsChange}
          initialValues={{
            name: "",
          }}
          onFinish={async (values) => {
            try {
              await create(values);
              form.resetFields();
              handleClose();
            } catch (error) {
              console.log(error);
            }
          }}
        >
          <Form.Item
            label="Nazwa"
            name="name"
            hasFeedback
            rules={[
              {
                required: true,
                message: "Nazwa jest wymagana!",
              },
              {
                pattern: name_regexp,
                message: "Pole zawiera niedozwolone znaki!!",
              },
            ]}
          >
            <Input placeholder="Nazwa" maxLength={30} showCount />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default CreateIssueKindModal;
